<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { DownloadImageData } from '../models/AllParts'
import FormHeader from './FormHeader.vue'
import RenderPartImage from './inventory/RenderPartImage.vue'

defineProps<{ image: DownloadImageData; header: string }>()
const { t } = useI18n({ useScope: 'global' })
</script>
<template>
  <q-card style="min-width: 280px" class="q-pa-md">
    <FormHeader :header-text="header" />
    <div class="row q-gutter-sm q-my-sm">
      <q-card-section class="q-pt-none">
        <RenderPartImage image-type="standard" :image-data="image" />
      </q-card-section>
    </div>
    <q-card-actions align="right" class="text-primary">
      <q-btn flat :label="t('form.close')" v-close-popup />
    </q-card-actions>
  </q-card>
</template>
